import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../../../commons/services/common.service';
import * as moment from 'moment';

@Component({
  selector: 'app-pgm-suspension-devis',
  templateUrl: './pgm-suspension-devis.component.html',
  styleUrls: ['./pgm-suspension-devis.component.css']
})
export class PgmSuspensionDevisComponent implements OnInit {
  @Input() programme;
  loadingIndicator: Boolean = false;
  qteSupp: Boolean = false;
  modifProgram = {};
  templistJourFerie = [];
  listePeriodesPause = [];

  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  constructor(public common: CommonService) { }

  ngOnInit() {
    this.modifProgram = Object.assign({}, this.programme);
    this.modifProgram['listePeriodesPause'] = this.modifProgram['listePeriodesPause'] || [];
    this.modifProgram['listePeriodesPause'].forEach(elt => {
      this.listePeriodesPause.push(Object.assign({}, elt));
    });
    // this.listePeriodesPause = this.modifProgram['listePeriodesPause'] || [];
    this.listePeriodesPause.forEach(elt => {
      elt.dateStart = this.isFullDate(elt.dateDebut) ?
        this.common.parseDate(moment(elt.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')) :
        this.common.parseDate(moment(elt.dateDebut, 'DD/MM/YYYY').format('DD/MM/YYYY'));
      elt.dateEnd = this.isFullDate(elt.dateFin) ?
        this.common.parseDate(moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')) :
        this.common.parseDate(moment(elt.dateFin, 'DD/MM/YYYY').format('DD/MM/YYYY'));

    });
  }

  isFullDate(date) {
    date = date || '';
    const regex = /^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d\d\d\d (20|21|22|23|[0-1]?\d):[0-5]?\d:[0-5]?\d$/;
    return date.match(regex) ? true : false;
  }

  showFiche() {
    this.hidefunction.emit();
  }

  save() {
    this.listePeriodesPause.forEach(elt => {
      elt.dateDebut =  moment(elt.dateStart).format('DD/MM/YYYY');
      elt.dateFin = moment(elt.dateEnd).format('DD/MM/YYYY');
      delete elt.dateStart;
      delete elt.dateEnd;
    });
    this.validefunction.emit(this.listePeriodesPause);
    this.hidefunction.emit();
  }

  addLigne() {
    const ctrl = this;
    this.listePeriodesPause.push({});
    this.listePeriodesPause = [...this.listePeriodesPause];
    setTimeout(function () {
      const elem = $('datatable-scroller:last-child')[0].lastElementChild;
      $('#qte' + (ctrl.listePeriodesPause.length - 1)).focus();
    }, 600);
  }

  deleteLigne(row) {
    const temp = this.listePeriodesPause.filter(elt => elt !== row);
    this.listePeriodesPause = temp;
  }
}
